import React from 'react'
import MonthRange from './MonthRange'
import GroupSelector from './GroupSelector'
import UnitSelector from './UnitSelector'

import styled from 'styled-components'
import * as actions from '../actions'
import { connect } from 'react-redux'
import { Button, Input, Icon } from 'antd'

const Container = styled.div`
  background-color: white;
  padding: 3em 2em 2em 2em;
  min-width: 65vw;
  position: relative;
  z-index: 800;
`
const LabelPane = styled.div`
  margin-top: 1em;
  margin-bottom: 0.2em;
  display: flex;
  align-items: center;
`
const Label = styled.label`
  font-size: 1.6em;
  font-weight: bold;
  margin-right: 1em;
  margin-bottom: 3px;
  flex: 0 0 3em;
`
const Buttons = styled.div`
  display: flex;
  justify-content center;
  align-items: center;
  margin-top: 1em;
 `

const EntitySelector = ({
  setAllUnits,
  setAllGroups,
  period,
  changePeriod,
  retrieveByUnit,
  retrieveByGroup,
  loading,
  hide,
  yearly,
  setYear,
  year,
  single,
}) => (
  <Container>
    <Icon
      type="close-square"
      theme="twoTone"
      onClick={hide}
      size="large"
      style={{
        position: 'absolute',
        top: '8px',
        right: '5px',
        fontSize: '30px',
      }}
    />
    {/* <Icon
      style={{
        position: 'absolute',
        top: '8px',
        right: '5px',
      }}
      onClick={hide}
      size="large"
      link
      name="close"
    /> */}
    {yearly ? (
      <Input value={year} onChange={e => setYear(e.target.value)} fluid />
    ) : (
      <MonthRange value={period} onChange={changePeriod} />
    )}
    <LabelPane>
      <Label>Group{!single && 's'}</Label>
      {!single && (
        <Button.Group size="mini" color="blue" basic>
          <Button disabled={loading} onClick={() => setAllGroups(true)}>
            All
          </Button>
          <Button disabled={loading} onClick={() => setAllGroups(false)}>
            Clear
          </Button>
        </Button.Group>
      )}
    </LabelPane>
    <GroupSelector multiple={!single} fluid disabled={loading} />
    <LabelPane>
      <Label>Unit{!single && 's'}</Label>
      {!single && (
        <Button.Group size="mini" color="blue" basic>
          <Button disabled={loading} onClick={() => setAllUnits(true)}>
            All
          </Button>
          <Button disabled={loading} onClick={() => setAllUnits(false)}>
            Clear
          </Button>
        </Button.Group>
      )}
    </LabelPane>
    <UnitSelector multiple={!single} disabled={loading} />
    <Buttons>
      <Button.Group size="mini" color="blue" basic>
        {retrieveByUnit && (
          <Button primary loading={loading} onClick={retrieveByUnit}>
            Generate Charts By Unit
          </Button>
        )}
        {retrieveByGroup && (
          <Button primary loading={loading} onClick={retrieveByGroup}>
            Generate Charts By Group
          </Button>
        )}
      </Button.Group>
    </Buttons>
  </Container>
)
//
export default connect(null, actions)(EntitySelector)
